"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessageList = void 0;
const react_1 = __importStar(require("react"));
const ChatMessage_1 = require("./ChatMessage");
const ChatMessageList = ({ messages, isTyping = false, userLabel, assistantLabel, assistantIcon, renderContent, emptyState, }) => {
    const endRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        endRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages, isTyping]);
    return (react_1.default.createElement("div", { className: "cw-chat-messages" },
        messages.length === 0 && emptyState,
        messages.map((msg, idx) => (react_1.default.createElement(ChatMessage_1.ChatMessage, { key: idx, message: msg, userLabel: userLabel, assistantLabel: assistantLabel, assistantIcon: assistantIcon, renderContent: renderContent }))),
        isTyping && (react_1.default.createElement("div", { className: "cw-chat-message cw-chat-message-assistant" },
            assistantIcon && (react_1.default.createElement("div", { className: "cw-chat-message-avatar" }, assistantIcon)),
            react_1.default.createElement("div", { className: "cw-chat-typing" },
                react_1.default.createElement("span", null),
                react_1.default.createElement("span", null),
                react_1.default.createElement("span", null)))),
        react_1.default.createElement("div", { ref: endRef })));
};
exports.ChatMessageList = ChatMessageList;
